(ns practitest.frontend.test-cloning-section
  (:require
    [ajax.core :as ajax]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.utils :as utils]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.overlay2 :as overlay2]
    [practitest.frontend.components.tooltip :as tooltip]
    [practitest.frontend.events :as events]
    [practitest.frontend.init :as init]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

;; subs
(re-frame/reg-sub
  ::state
  (fn [db _]
    (:test-cloning-section-state db)))

(re-frame/reg-sub
  ::labels
  :<- [::state]
  (fn [{:keys [labels]} _]
    labels))

(re-frame/reg-sub
  ::parent-link
  :<- [::state]
  (fn [{:keys [parent-link]} _]
    parent-link))

(re-frame/reg-sub
  ::corporate-permission?
  :<- [::state]
  (fn [{:keys [corporate-permission?]} _]
    corporate-permission?))

(re-frame/reg-sub
  ::parent-diff?
  :<- [::state]
  (fn [{:keys [parent-diff?]} _]
    parent-diff?))

(re-frame/reg-sub
  ::permission-to-view-parent?
  :<- [::state]
  (fn [{:keys [permission-to-view-parent?]} _]
    permission-to-view-parent?))

(re-frame/reg-sub
  ::permission-to-edit-test?
  :<- [::state]
  (fn [{:keys [permission-to-edit-test?]} _]
    permission-to-edit-test?))

;; events
(re-frame/reg-event-db
  ::init-test-cloning-section
  (fn [db [_ data]]
    (update db :test-cloning-section-state merge data)))

(defn update-from-parent-data [{:keys [db]} _]
  {:db         (update db :progress conj ::update-from-parent-data)
   :http-xhrio {:method          :post
                ;; This is fine for now
                :uri             (get-in db [:test-cloning-section-state :update-from-parent-data-uri])
                :params          {}
                :format          (ajax/json-request-format)
                :response-format (ajax/json-response-format {:keywords? true})
                :on-success      [::update-from-parent-data-completed]
                :on-failure      [::bad-http-result ::update-from-parent-data]}})

(re-frame/reg-event-fx ::update-from-parent-data update-from-parent-data)

(defn update-from-parent-data-completed [_]
  (js/location.reload))

(re-frame/reg-event-fx ::update-from-parent-data-completed update-from-parent-data-completed)

;; views
(defn not-corporate-tooltip [_]
  (let [root-ref (atom nil)
        tooltip-overlay-state (reagent/atom {})
        labels @(re-frame/subscribe [::labels])
        {{:keys [title text1 text2 link text3]} :not-corporate-msg} labels]
    (fn [{:keys [webcomponent?] :as options}]
      [:span
       {:class (dom/classes-pairs :webcomponent webcomponent?)
        :ref   (dom/root-ref-handler root-ref)}
       [:<>
        [:span
         (let [hide! (fn []
                       (swap! tooltip-overlay-state assoc :show-not-corporate-tooltip? false))
               toggle! (fn []
                         (swap! tooltip-overlay-state update :show-not-corporate-tooltip? not))
               show? (:show-not-corporate-tooltip? @tooltip-overlay-state)]
           [overlay2/floating-ui-overlay
            {:placement        "top"
             :offset           20
             :container        root-ref
             :show?            show?
             :on-request-close hide!}
            ;; Target
            [:span
             {:id "not-corporate-icon"
              :on-click (fn [_]
                          (toggle!))}
             [icons/mux-not-corporate]]
            ;; Body
            [:div.not-corporation-popup
             [:h6 title]
             [:p
              [:p text1]
              [:p (str text2 " ")
               [:a.corporate-licence-link
                {:href link}
                "Corporate licence"]
               (str " " text3)]]]])]]])))


(defn test-cloning-section-data [_]
  (let [parent-link @(re-frame/subscribe [::parent-link])
        corporate-permission? @(re-frame/subscribe [::corporate-permission?])
        parent-diff? @(re-frame/subscribe [::parent-diff?])
        confirmed? (reagent/atom false)
        labels @(re-frame/subscribe [::labels])
        view-parent-permission @(re-frame/subscribe [::permission-to-view-parent?])
        enabled? (and @(re-frame/subscribe [::permission-to-edit-test?])
                      view-parent-permission)]
    [:div
     [:div.row.bottom-line
      [:span {:style {:margin-bottom 0}}
       [:span.clone-section
        (:cloning labels)]
       [:div.clone-pull-right

        (if parent-diff?
          [:<>
           [icons/mux-ancestor-has-changes]
           [:span.font1 (:updates-in-ancestor labels)]
           (if corporate-permission?
             [tooltip/mux-tooltip
              {:position "top"}
              (if enabled?
                (:update-this-test labels)
                (:no-permission labels))
              (fn [props]
                [:span.update-this-test-tooltip
                 (assoc props
                   :id "update-this-test-tooltip"
                   :on-click (fn [e]
                               (when enabled?
                                 (dom/prevent-default e)
                                 (reset! confirmed? (js/window.confirm (:update-this-test? labels)))
                                 (when @confirmed?
                                   (mixpanel/track "Refresh Clone" {"Entity" "Test"})
                                   (re-frame/dispatch [::update-from-parent-data])))))
                 (if enabled?
                   [icons/mux-refresh-changes]
                   [icons/mux-refresh-changes-disabled])])]
             [not-corporate-tooltip])]
          [:<>
           [:span.font1
            (:no-available-updates labels)]])]]]

     [:<>
      [:div.font2 (:ancestor labels)]]
     (if view-parent-permission
       [:div.row
        [:a.parent-link
         {:dangerouslySetInnerHTML
          {:__html parent-link}}]]
       [:div.row
        [:p parent-link]])]))

(defn ^:dev/after-load mount-root []
  (init/remount-roots "test-cloning-section-component"
                      test-cloning-section-data))

(defn ^:export init [webcomponent options]
  (init/init! {:options       options
               :init-event-fn (fn [config]
                                [::init-test-cloning-section config])
               :webcomponent  webcomponent
               :root-view     test-cloning-section-data}))

(utils/register-webcomponent! "test-cloning-section-component")
